var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 511,
    height: 591,
    viewBox: "0 0 511 591",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.8455 442.731H1V516.198H73.8455V442.731Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8455 516.198H1V589.665H73.8455V516.198Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M146.697 442.731H73.8511V516.198H146.697V442.731Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M146.697 516.198H73.8511V589.665H146.697V516.198Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M219.58 442.731H146.696V516.198H219.58V442.731Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M219.58 516.198H146.696V589.665H219.58V516.198Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M292.426 442.731H219.58V516.198H292.426V442.731Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M292.426 516.198H219.58V589.665H292.426V516.198Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M365.309 442.731H292.425V516.198H365.309V442.731Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M365.309 516.198H292.425V589.665H365.309V516.198Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M438.155 442.731H365.309V516.198H438.155V442.731Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M438.155 516.198H365.309V589.665H438.155V516.198Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M511 442.731H438.155V516.198H511V442.731Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M511 516.198H438.155V589.665H511V516.198Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8455 295.458H1V368.925H73.8455V295.458Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8455 368.925H1V442.392H73.8455V368.925Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M146.697 295.458H73.8511V368.925H146.697V295.458Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M146.697 368.925H73.8511V442.392H146.697V368.925Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M219.58 295.458H146.696V368.925H219.58V295.458Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M219.58 368.925H146.696V442.392H219.58V368.925Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M292.426 295.458H219.58V368.925H292.426V295.458Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M292.426 368.925H219.58V442.392H292.426V368.925Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M365.309 295.458H292.425V368.925H365.309V295.458Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M365.309 368.925H292.425V442.392H365.309V368.925Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M438.155 295.458H365.309V368.925H438.155V295.458Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M438.155 368.925H365.309V442.392H438.155V368.925Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M511 295.458H438.155V368.925H511V295.458Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M511 368.925H438.155V442.392H511V368.925Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8455 148.185H1V221.652H73.8455V148.185Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8455 221.652H1V295.12H73.8455V221.652Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M146.697 148.185H73.8511V221.652H146.697V148.185Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M146.697 221.652H73.8511V295.12H146.697V221.652Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M219.58 148.185H146.696V221.652H219.58V148.185Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M219.58 221.652H146.696V295.12H219.58V221.652Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M292.426 148.185H219.58V221.652H292.426V148.185Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M292.426 221.652H219.58V295.12H292.426V221.652Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M365.309 148.185H292.425V221.652H365.309V148.185Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M365.309 221.652H292.425V295.12H365.309V221.652Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M438.155 148.185H365.309V221.652H438.155V148.185Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M438.155 221.652H365.309V295.12H438.155V221.652Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M511 148.185H438.155V221.652H511V148.185Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M511 221.652H438.155V295.12H511V221.652Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8455 0.912354H1V74.3796H73.8455V0.912354Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8455 74.3796H1V147.847H73.8455V74.3796Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M146.697 0.912354H73.8511V74.3796H146.697V0.912354Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M146.697 74.3796H73.8511V147.847H146.697V74.3796Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M219.58 0.912354H146.696V74.3796H219.58V0.912354Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M219.58 74.3796H146.696V147.847H219.58V74.3796Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M292.426 0.912354H219.58V74.3796H292.426V0.912354Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M292.426 74.3796H219.58V147.847H292.426V74.3796Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M365.309 0.912354H292.425V74.3796H365.309V0.912354Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M365.309 74.3796H292.425V147.847H365.309V74.3796Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M438.155 0.912354H365.309V74.3796H438.155V0.912354Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M438.155 74.3796H365.309V147.847H438.155V74.3796Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M511 0.912354H438.155V74.3796H511V0.912354Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M511 74.3796H438.155V147.847H511V74.3796Z",
    stroke: "#F5F5F5",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349.196 234.82C387.127 234.82 418.109 203.576 418.109 165.318C418.109 127.06 387.127 95.8159 349.196 95.8159C311.265 95.8159 280.283 127.021 280.283 165.318C280.283 203.614 311.227 234.82 349.196 234.82Z",
    fill: "white",
    stroke: "#545252",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M360.275 184.867C379.458 184.867 395.107 169.082 395.107 149.734C395.107 130.387 379.458 114.602 360.275 114.602C341.091 114.602 325.442 130.387 325.442 149.734C325.442 169.082 341.091 184.867 360.275 184.867Z",
    fill: "#545252",
    stroke: "#545252",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M382.043 176.816C376.087 181.502 368.62 184.349 360.476 184.349C344.232 184.349 330.569 173.091 326.712 157.911C332.232 150.1 341.331 145.011 351.574 145.011C368.418 145.011 382.038 158.751 382.038 175.736V176.816H382.043Z",
    fill: "white",
    stroke: "#545252",
    strokeWidth: 0.545455,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.823 119.532C183.05 119.532 193.812 108.678 193.812 95.3797C193.812 82.0815 183.05 71.1833 169.823 71.1833C156.596 71.1833 145.872 82.0379 145.872 95.3797C145.872 108.722 156.634 119.532 169.823 119.532Z",
    fill: "white",
    stroke: "#545252",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.674 102.149C180.345 102.149 185.789 96.6615 185.789 89.9306C185.789 83.1997 180.345 77.7124 173.674 77.7124C167.003 77.7124 161.56 83.1997 161.56 89.9306C161.56 96.6615 167.003 102.149 173.674 102.149Z",
    fill: "#545252",
    stroke: "#545252",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.261 99.3452C179.194 100.987 176.576 101.991 173.756 101.991C168.116 101.991 163.349 98.0634 162.04 92.7779C163.949 90.0943 167.085 88.2888 170.658 88.2888C176.538 88.2888 181.261 93.0943 181.261 98.9852V99.3452Z",
    fill: "white",
    stroke: "#545252",
    strokeWidth: 0.545455,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99414 119.331L23.1778 91.5396L59.9305 60.8578L55.9432 80.9742L9.99414 119.331Z",
    fill: "#545252",
    stroke: "#545252",
    strokeWidth: 0.616364,
    strokeLinejoin: "bevel"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.9434 80.9742L59.9306 60.8578L93.2143 101.429L97.5397 131.674L55.9434 80.9742Z",
    fill: "white",
    stroke: "#545252",
    strokeWidth: 0.616364,
    strokeLinejoin: "bevel"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99414 119.331L55.9432 80.9742L97.5396 131.674L51.6178 170.031L9.99414 119.331Z",
    fill: "#545252",
    stroke: "#545252",
    strokeWidth: 0.616364,
    strokeLinejoin: "bevel"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M112.91 104.281C116.009 99.716 122.167 98.5924 126.694 101.718C131.183 104.843 132.296 111.094 129.198 115.616C126.972 118.9 125.107 122.063 123.64 125.151C122.21 128.156 121.136 130.998 120.421 133.681C114.383 155.712 130.272 173.658 145.365 190.643C166.856 214.916 186.989 237.634 162.405 271.038C159.149 275.483 152.952 276.405 148.583 273.121C144.176 269.838 143.26 263.587 146.516 259.141C161.489 238.791 146.554 221.925 130.627 203.941C112.038 182.991 92.4177 160.84 101.314 128.352C102.389 124.469 103.856 120.503 105.803 116.494C107.669 112.529 110.052 108.481 112.91 104.276V104.281Z",
    fill: "white",
    stroke: "#545252",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.806 263.276C158.784 265.518 159.815 269.205 158.151 271.409C156.482 273.651 152.707 273.651 149.729 271.409C146.751 269.123 145.72 265.48 147.384 263.238C149.053 260.996 152.827 261.034 155.806 263.276Z",
    fill: "#545252"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.298 263.941C238.496 263.941 252.476 278.003 252.476 295.387C252.476 312.77 238.496 326.794 221.298 326.794C204.1 326.794 190.12 312.732 190.12 295.387C190.12 278.041 204.061 263.941 221.298 263.941ZM221.298 281.609C229.518 281.609 236.194 288.296 236.194 296.592C236.194 304.889 229.523 311.614 221.298 311.614C213.072 311.614 206.401 304.883 206.401 296.592C206.401 288.301 213.072 281.609 221.298 281.609Z",
    fill: "#545252",
    stroke: "#545252",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.298 276.721C238.496 276.721 252.476 290.821 252.476 308.167C252.476 325.512 238.496 339.612 221.298 339.612C204.1 339.612 190.12 325.551 190.12 308.167C190.12 290.783 204.061 276.721 221.298 276.721ZM221.298 294.389C229.518 294.389 236.194 301.12 236.194 309.411C236.194 317.701 229.523 324.432 221.298 324.432C213.072 324.432 206.401 317.701 206.401 309.411C206.401 301.12 213.072 294.389 221.298 294.389Z",
    fill: "white",
    stroke: "#545252",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M358.741 266.571C363.748 264.367 369.585 266.652 371.767 271.736C373.954 276.782 371.647 282.672 366.645 284.876C326.09 302.74 329.188 329.102 332.128 354.34C335.505 383.26 338.761 411.062 300.274 430.289C295.387 432.732 289.43 430.731 287.008 425.762C284.587 420.836 286.61 414.825 291.498 412.382C317.434 399.405 314.974 378.454 312.432 356.62C308.658 324.214 304.687 290.363 358.747 266.571H358.741Z",
    fill: "white",
    stroke: "#545252",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M296.025 429.525C300.274 429.525 303.771 426.04 303.771 421.834C303.771 417.629 300.274 414.143 296.025 414.143C291.776 414.143 288.28 417.591 288.28 421.834C288.28 426.078 291.776 429.525 296.025 429.525Z",
    fill: "#545252"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M265.403 41.1179C269.2 38.3251 274.534 39.1433 277.332 43.0106C280.12 46.8451 279.291 52.2288 275.494 55.0215C244.752 77.6742 252.318 99.2524 259.534 119.925C267.814 143.609 275.783 166.376 247.032 189.782C243.383 192.754 238 192.192 235.027 188.472C232.065 184.785 232.638 179.352 236.287 176.38C255.656 160.589 249.645 143.434 243.4 125.554C234.132 99.0124 224.423 71.2979 265.409 41.1179H265.403Z",
    fill: "white",
    stroke: "#545252",
    strokeWidth: 0.692727,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.312 189.945C246.885 189.143 249.17 185.56 248.379 182.02C247.583 178.447 243.994 176.211 240.421 177.007C236.849 177.809 234.558 181.36 235.354 184.932C236.145 188.467 239.739 190.742 243.312 189.945Z",
    fill: "#545252"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0542 358.823L34.1469 319.365L96.4269 301.698L89.9524 337.032L13.0542 358.823Z",
    fill: "white",
    stroke: "#545252",
    strokeWidth: 0.801818,
    strokeLinejoin: "bevel"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.9521 337.032L96.4267 301.698L110.249 351.291L106.992 398.243L89.9521 337.032Z",
    fill: "#545252",
    stroke: "#545252",
    strokeWidth: 0.801818,
    strokeLinejoin: "bevel"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0542 358.823L89.9524 337.032L106.992 398.243L30.1378 420.034L13.0542 358.823Z",
    fill: "white",
    stroke: "#545252",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M407.385 263.581L426.05 226.529L488.33 208.861L484.283 241.752L407.385 263.581Z",
    fill: "#545252",
    stroke: "#545252",
    strokeWidth: 0.801818,
    strokeLinejoin: "bevel"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M484.283 241.752L488.33 208.861L502.158 258.454L501.361 303.001L484.283 241.752Z",
    fill: "white",
    stroke: "#545252",
    strokeWidth: 0.801818,
    strokeLinejoin: "bevel"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M407.385 263.582L484.283 241.752L501.361 303.002L424.463 324.792L407.385 263.582Z",
    fill: "white",
    stroke: "#545252",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9325 549.672C54.1215 549.672 64.8834 538.818 64.8834 525.52C64.8834 512.222 54.1215 501.323 40.9325 501.323C27.7434 501.323 16.9434 512.178 16.9434 525.52C16.9434 538.862 27.7052 549.672 40.9325 549.672Z",
    fill: "white",
    stroke: "#545252",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.7835 532.327C51.4544 532.327 56.898 526.84 56.898 520.109C56.898 513.378 51.4544 507.852 44.7835 507.852C38.1126 507.852 32.6689 513.34 32.6689 520.109C32.6689 526.878 38.1126 532.327 44.7835 532.327Z",
    fill: "#545252",
    stroke: "#545252",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.3322 529.48C50.2649 531.122 47.6849 532.125 44.8649 532.125C39.1867 532.125 34.4576 528.198 33.1104 522.951C35.0194 520.229 38.194 518.423 41.7667 518.423C47.6031 518.423 52.3704 523.229 52.3704 529.12C52.3704 529.24 52.3322 529.36 52.3322 529.48Z",
    fill: "white",
    stroke: "#545252",
    strokeWidth: 0.545455,
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.34 376.398C474.541 356.625 460.878 337.851 440.936 334.627C420.934 331.387 402.045 344.892 398.849 364.665C395.641 384.498 409.305 403.272 429.301 406.507C449.243 409.736 468.132 396.231 471.34 376.398Z",
    fill: "white",
    stroke: "#545252",
    strokeWidth: 1.21636,
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M446.265 366.411C447.885 356.407 440.974 346.916 430.889 345.28C420.738 343.638 411.187 350.462 409.572 360.471C407.952 370.474 414.863 379.965 425.009 381.607C435.1 383.238 444.651 376.414 446.265 366.411Z",
    fill: "#545252",
    stroke: "#545252",
    strokeWidth: 1.21636,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M443.832 354.405C445.796 357.902 446.669 362.014 445.987 366.242C444.607 374.756 437.576 380.892 429.378 381.645C425.756 378.127 423.825 372.923 424.692 367.562C426.11 358.807 434.472 352.829 443.303 354.258C443.483 354.285 443.652 354.378 443.832 354.405Z",
    fill: "white",
    stroke: "#545252",
    strokeWidth: 0.545455,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M468.591 30.0397C485.827 30.0397 499.769 44.1397 499.769 61.4851C499.769 78.8306 485.827 92.9306 468.591 92.9306C451.354 92.9306 437.451 78.8688 437.451 61.4851C437.451 44.1015 451.392 30.0397 468.591 30.0397ZM468.591 47.7069C476.811 47.7069 483.487 54.4379 483.487 62.7288C483.487 71.0197 476.816 77.7506 468.591 77.7506C460.365 77.7506 453.738 71.0197 453.738 62.7288C453.738 54.4379 460.371 47.7069 468.591 47.7069Z",
    fill: "#545252",
    stroke: "#545252",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M468.591 42.8633C485.827 42.8633 499.769 56.9251 499.769 74.3087C499.769 91.6924 485.827 105.754 468.591 105.754C451.354 105.754 437.451 91.6542 437.451 74.3087C437.451 56.9633 451.392 42.8633 468.591 42.8633ZM468.591 60.5251C476.811 60.5251 483.487 67.256 483.487 75.5469C483.487 83.8378 476.816 90.5306 468.591 90.5306C460.365 90.5306 453.738 83.8433 453.738 75.5469C453.738 67.2506 460.371 60.5251 468.591 60.5251Z",
    fill: "white",
    stroke: "#545252",
    strokeWidth: 0.801818,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.e53f91aad4bf00f3698ea9f87ddecf87.svg";
export { ForwardRef as ReactComponent };